import { render, staticRenderFns } from "./xiaoQuList.vue?vue&type=template&id=2e62edac&scoped=true"
import script from "./xiaoQuList.vue?vue&type=script&lang=js"
export * from "./xiaoQuList.vue?vue&type=script&lang=js"
import style0 from "./xiaoQuList.vue?vue&type=style&index=0&id=2e62edac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e62edac",
  null
  
)

export default component.exports